import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
import Login from "./views/Login";
import LoginWK from "./views/LoginWK";
import ResetPassword from "./views/ResetPassword";
import RemindPassword from "./views/RemindPassword";
import ChangingExpiredPassword from "./views/ChangingExpiredPassword";

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "Login",
      path: "/login",
      component: Login,
      props: (route) => Object.assign({}, route.params, route.query)
    },
    {
      name: "LoginWK",
      path: "/login-wk",
      component: LoginWK,
      props: (route) => Object.assign({}, route.params, route.query)
    },
    {
      name: "RemindPassword",
      path: "/remin-paswd",
      component: RemindPassword,
      props: (route) => Object.assign({}, route.params, route.query)
    },
    {
      name: "ResetPaswd",
      path: "/reset-paswd",
      component: ResetPassword,
      props: (route) => Object.assign({}, route.params, route.query)
    },
    {
      name: "ChangingExpiredPassword",
      path: "/changing-expired-paswd",
      component: ChangingExpiredPassword,
      props: (route) => Object.assign({}, route.params, route.query)
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
